import { render } from "./Icon.vue?vue&type=template&id=21801504"
import script from "./Icon.vue?vue&type=script&lang=js"
export * from "./Icon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icons/Icon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "21801504"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('21801504', __exports__)) {
    api.reload('21801504', __exports__)
  }
  
  module.hot.accept("./Icon.vue?vue&type=template&id=21801504", () => {
    api.rerender('21801504', render)
  })

}


export default __exports__